import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/clipboard-check-outline';

const routes: RouteRecordRaw[] = [
	{
		path: '/service-history-review',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			isAllowed: ({ canAccessServiceHistoryReview }) => canAccessServiceHistoryReview || ROOT_PAGES.MODULES,
			documentTitle: 'Service history review',
			title: 'Service history review',
		},
	},
];

/** Not built here: motorway/mw-vehicle-history (apps/service-history-review), loaded at runtime as a Module Federation remote. */
export const SERVICE_HISTORY_REVIEW_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'Service history review',
	description: 'Review service-history documents read by the extractor, and curate the golden set',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessServiceHistoryReview }) => canAccessServiceHistoryReview,
	routes,
};
